import React, { memo, useReducer, useRef } from 'react';
import { Space } from '@redlink/components/atoms';
import {TextInput, useAlert} from '@redlink/components/molecules';
import { AuthPageContainerTemplate } from '@redlink/components/templates';
import { useLocale } from '@redlink/assets/locale';
import { useMutation, signUpQuery } from '@redlink/services';
import { initialState, reducer, types } from './store';
import { AuthCustomAction } from '@redlink/components/muscles';
import { useValues } from '@redlink/assets/values';

export const RegisterPage = memo(({ navigation }) => {
  const { dictionary } = useLocale();
  const alert = useAlert();
  const authContainerRef = useRef(null);
  const { routes } = useValues();

  const [{ username, password, confirmPassword }, dispatch] = useReducer(
    reducer,
    initialState
  );

  const [signUp, { loading: signUpIsBusy }] = useMutation(signUpQuery, {
    done: async ({ SignUp }) =>
      await authContainerRef.current.onAuthSuccess(SignUp),
  });

  const onSignUpPressed = () => {
    if (password !== confirmPassword) {
      alert.show(dictionary.passwordNotEqualWithConfirm, { type: 'error' });
      return;
    }

    signUp({
      username,
      password,
    });
  };

  return (
    <AuthPageContainerTemplate
      ref={authContainerRef}
      isBusy={signUpIsBusy}
      title={dictionary.register}
      actions={[
        {
          title: dictionary.register,
          variant: 'custom',
          children: (
            <AuthCustomAction
              title={dictionary.haveAccount}
              subtitle={dictionary.loginFromHere}
              onPress={() => {
                navigation.navigate(routes.login.key);
              }}
            />
          ),
        },
        {
          title: dictionary.register,
          variant: 'primary',
          onPress: onSignUpPressed,
        },
      ]}
    >
      <TextInput
        require
        value={username}
        onChangeText={(value) =>
          dispatch({ type: types.SET_USERNAME, payload: value })
        }
        title={dictionary.email}
        keyboardType="email-address"
      />
      <Space size={16} />
      <TextInput
        require
        value={password}
        onChangeText={(value) =>
          dispatch({ type: types.SET_PASSWORD, payload: value })
        }
        title={dictionary.password}
        secureTextEntry
      />
      <Space size={16} />
      <TextInput
        require
        value={confirmPassword}
        onChangeText={(value) =>
          dispatch({ type: types.SET_CONFIRM_PASSWORD, payload: value })
        }
        title={dictionary.confirmPassword}
        secureTextEntry
      />
    </AuthPageContainerTemplate>
  );
});
